import { render, staticRenderFns } from "./TenancyInformation.vue?vue&type=template&id=5124d8e6&scoped=true&"
import script from "./TenancyInformation.vue?vue&type=script&lang=js&"
export * from "./TenancyInformation.vue?vue&type=script&lang=js&"
import style0 from "./TenancyInformation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TenancyInformation.vue?vue&type=style&index=1&id=5124d8e6&lang=scss&scoped=true&"
import style2 from "./TenancyInformation.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124d8e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5124d8e6')) {
      api.createRecord('5124d8e6', component.options)
    } else {
      api.reload('5124d8e6', component.options)
    }
    module.hot.accept("./TenancyInformation.vue?vue&type=template&id=5124d8e6&scoped=true&", function () {
      api.rerender('5124d8e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/edit/TenancyInformation.vue"
export default component.exports